import { MathUtil } from "./MathUtil";
import { ICard, ICardReference, CardType, Card, CardSlot, CardSubType } from "./Card";
import { StringUtil } from "./StringUtil";


export class CardUtil {
    static customDeckBuilderRulesKey="customDeckBuilderRules";

    static distinct(cards: ICard[]): ICard[] {
        const index = new Set<string>();
        return cards.filter((card: ICard) => {
            //make sure that duplicate cards is not checked more than once
            const key = CardUtil.getKey(card);
            if (index.has(key)) return false;
            index.add(key);
            return true;
        });
    }
    static getKey(card: ICard): string {
        return card.pack + ":" + card.packNumber;
    }
    static getFullDisplayName(card: ICard): string {
        return `AHC${StringUtil.padWithZero(card.pack, 2)}:${StringUtil.padWithZero(card.packNumber, 3)} ${card.name}`;
    }
    static getFrontUrl(card: ICard): string {
        return "/Content/cards/AHC01_" + card.packNumber + ".jpg";
    }
    static getBackUrl(card: ICard): string {
        return "/Content/cards/AHC01_" + card.packNumber + "b.jpg";
    }
    static getUrl(card: ICard): string {
        if (card.faceUp) {
            return this.getFrontUrl(card);
        }
        return this.getBackUrl(card);
    }
    static getCardReferenceCss(card: ICardReference, faceUp?: boolean, exhausted?: boolean) {
        if (!card) return "";
        let css = `card hires card-pack-${card.pack} card-${card.packNumber}`;
       
        if (faceUp)
            css += " faceup";
        if (exhausted) {
            css += " exhausted";
        }
        return css;
    }
    static getCardCss(card: ICard, faceUp?: boolean): string {
        if (!card) return "";
        if (faceUp === undefined) {
            faceUp = card.faceUp;
        }
        return CardUtil.getCardReferenceCss(card, faceUp, card.exhausted);
    }

    static equals(a: ICardReference, b: ICardReference): boolean {
        if (a === b) return true;
        if (!a || !b) return false;
        if (a.pack !== b.pack) return false;
        if (a.packNumber !== b.packNumber) return false;
        return true;
    }
    static shuffle(array: ICard[]): ICard[] {

        // if it's 1 or 0 items, just return
        if (array.length <= 1) return array;

        // For each index in array
        for (let i = 0; i < array.length; i++) {

            // choose a random not-yet-placed item to place there
            // must be an item AFTER the current item, because the stuff
            // before has all already been placed
            const randomChoiceIndex = MathUtil.random(i, array.length - 1);

            // place our random choice in the spot by swapping
            [array[i], array[randomChoiceIndex]] = [array[randomChoiceIndex], array[i]];
        }

        return array;
    }
    static flipCard(card: ICard, faceUp: boolean): ICard {
        card.faceUp = faceUp;
        return card;
    }
    static flip(cards: ICard[], faceUp: boolean): ICard[] {
        if (!cards || !cards.length) return cards;
        for (let i = 0; i < cards.length; i++) {
            cards[i].faceUp = faceUp;
        }
        return cards;
    }
    static removeCardsOfName(cards: ICard[], name: string): ICard[] {
        const foundCards: ICard[] = [];
        for (let i = 0; i < cards.length; i++) {
            const c = cards[i];
            if (c.name !== name) {
                continue;
            }
            foundCards.push(c);
            cards.splice(i, 1);
            i--;
        }
        return foundCards;
    }
    static removeCardsOfType(cards: ICard[], cardType: CardType): ICard[] {
        const foundCards: ICard[] = [];
        for (let i = 0; i < cards.length; i++) {
            const c = cards[i];
            if (c.type !== cardType) {
                continue;
            }
            foundCards.push(c);
            cards.splice(i, 1);
            i--;
        }
        return foundCards;
    }
    static removeCardsOfSet(cards: ICard[], set: string) {
        const foundCards: ICard[] = [];
        for (let i = 0; i < cards.length; i++) {
            const c = cards[i];
            if (c.set !== set) {
                continue;
            }
            foundCards.push(c);
            cards.splice(i, 1);
            i--;
        }
        return foundCards;
    }
    static removeCard(cards: ICard[], p: ICardReference): ICard {
        for (let i = 0; i < cards.length; i++) {
            const c = cards[i];
            if (c.pack === p.pack && c.packNumber === p.packNumber) {
                cards.splice(i, 1);
                return c;
            }
        }
        return null;
    }

    static backToTop(cards: ICard[]) {
        if (cards.length < 2) return;
        const card = cards.splice(cards.length - 1, 1)[0];
        cards.splice(0, 0, card);
    }

    static topToBack(cards: ICard[]) {
        if (cards.length < 2) return;
        const card = cards.splice(0, 1)[0];
        cards.splice(cards.length, 0, card);
    }

    static randomCard(cards: ICard[]): ICard {
        if (!cards || !cards.length) return null;
        const index = MathUtil.random(0, cards.length - 1);
        return cards[index];
    }
    static getSubTypeSymbol(subType:CardSubType):string{
        switch (subType) {
            case CardSubType.Guardian: return "faa fa-guardian";
            case CardSubType.Seeker: return "faa fa-seeker";
            case CardSubType.Survivor: return "faa fa-survivor";
            case CardSubType.Rouge: return "faa fa-rouge";
            case CardSubType.Mystic: return "faa fa-mystic";
            case CardSubType.Neutral: return "faa fa-star";
            case CardSubType.Guardian: return "faa fa-guardian";
            case  CardSubType.BasicWeakness:
            case CardSubType.Weakness:return  "faa fa-weakness";
            default: return "";
        }
    }
}